import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import * as _ from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q17',
  templateUrl: './r-q17.component.html',
  styleUrls: ['./r-q17.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ17Component implements OnInit {
  hoursSpend;
  @Input() data: any;
  isDisable;
  showTip;
  question;
  isChecked;
  questions;
  userResponses = [];
  index;
  questionObj;
  showbutton = true;
  hgType = {
    opt1: false,
    opt2: false,
    opt3: false,
    opt4: false,
    opt5: false
  };
  property;
  messagetype;
  deviceWidth;
  user_bot;
  spend1_id;
  spend2_id;
  spend3_id;
  spend4_id;
  spend5_id;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.spend1_id = document.getElementById('option1_mob');
      this.spend2_id = document.getElementById('option2_mob');
      this.spend3_id = document.getElementById('option3_mob');
      this.spend4_id = document.getElementById('option4_mob');
      this.spend5_id = document.getElementById('option5_mob');
    } else {
      this.spend1_id = document.getElementById('option1');
      this.spend2_id = document.getElementById('option2');
      this.spend3_id = document.getElementById('option3');
      this.spend4_id = document.getElementById('option4');
      this.spend5_id = document.getElementById('option5');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (!_.isEmpty(this.property)) {
      if (this.property === 'Apartment or condominium') {
        this.question = this.question.replace('home', 'apartment');
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.hoursSpend = obj.fieldValue;
      }
      if (!_.isEmpty(this.hoursSpend)) {
        this.user_bot = true;
        if (this.hoursSpend === 'Atleast one of us stays/works from home.') {
          this.hgType = {
            opt1: true,
            opt2: false,
            opt3: false,
            opt4: false,
            opt5: false
          };
          this.spend1_id.parentElement.classList.add('active-select');
        } else if (this.hoursSpend === 'I/we work a regular "8 to 5" job.') {
          this.hgType = {
            opt1: false,
            opt2: true,
            opt3: false,
            opt4: false,
            opt5: false
          };
          this.spend2_id.parentElement.classList.add('active-select');
        } else if (this.hoursSpend === 'I/we only come home to sleep.') {
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: true,
            opt4: false,
            opt5: false
          };
          this.spend3_id.parentElement.classList.add('active-select');
        } else if (this.hoursSpend === 'Hard to tell. It/s different every day.') {
          this.hoursSpend = "Hard to tell. It's different every day."
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: false,
            opt4: true,
            opt5: false
          };
          this.spend4_id.parentElement.classList.add('active-select');
        } else {
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: false,
            opt4: false,
            opt5: true
          };
          this.spend5_id.parentElement.classList.add('active-select');
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if(!this.hgType.opt1 && !this.hgType.opt2 &&  !this.hgType.opt3 &&  !this.hgType.opt4 && !this.hgType.opt5)
    {
      this.showbutton = false;
    }
  }

  getType(event) {
    this.hoursSpend = event.target.value;
    this.isChecked = event.target.checked;
    const elements = document.getElementsByName('active-select');
    if (this.isChecked === true) {
      if (!_.isEmpty(this.hoursSpend)) {
        if (this.deviceWidth < 768) {
          this.residentialService.unSelectService({'currentId': this.data});
        }
        if (this.hoursSpend === 'Atleast one of us stays/works from home.') {
          this.hgType = {
            opt1: true,
            opt2: false,
            opt3: false,
            opt4: false,
            opt5: false
          };
          this.spend1_id.parentElement.classList.add('active-select');
          if (_.contains(this.spend2_id.parentElement.classList, 'active-select')) {
            this.spend2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend3_id.parentElement.classList, 'active-select')) {
            this.spend3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend4_id.parentElement.classList, 'active-select')) {
            this.spend4_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend5_id.parentElement.classList, 'active-select')) {
            this.spend5_id.parentElement.classList.remove('active-select');
          }
        } else if (this.hoursSpend === 'I/we work a regular "8 to 5" job.') {
          this.hgType = {
            opt1: false,
            opt2: true,
            opt3: false,
            opt4: false,
            opt5: false
          };
          this.spend2_id.parentElement.classList.add('active-select');
          if (_.contains(this.spend1_id.parentElement.classList, 'active-select')) {
            this.spend1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend3_id.parentElement.classList, 'active-select')) {
            this.spend3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend4_id.parentElement.classList, 'active-select')) {
            this.spend4_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend5_id.parentElement.classList, 'active-select')) {
            this.spend5_id.parentElement.classList.remove('active-select');
          }
        } else if (this.hoursSpend === 'I/we only come home to sleep.') {
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: true,
            opt4: false,
            opt5: false
          };
          this.spend3_id.parentElement.classList.add('active-select');
          if (_.contains(this.spend2_id.parentElement.classList, 'active-select')) {
            this.spend2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend1_id.parentElement.classList, 'active-select')) {
            this.spend1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend4_id.parentElement.classList, 'active-select')) {
            this.spend4_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend5_id.parentElement.classList, 'active-select')) {
            this.spend5_id.parentElement.classList.remove('active-select');
          }
        } else if (this.hoursSpend === 'Hard to tell. It/s different every day.' ) {
          this.hoursSpend = "Hard to tell. It's different every day."
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: false,
            opt4: true,
            opt5: false
          };
          this.spend4_id.parentElement.classList.add('active-select');
          if (_.contains(this.spend2_id.parentElement.classList, 'active-select')) {
            this.spend2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend3_id.parentElement.classList, 'active-select')) {
            this.spend3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend1_id.parentElement.classList, 'active-select')) {
            this.spend1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend5_id.parentElement.classList, 'active-select')) {
            this.spend5_id.parentElement.classList.remove('active-select');
          }
        } else {
          this.hgType = {
            opt1: false,
            opt2: false,
            opt3: false,
            opt4: false,
            opt5: true
          };
          if (_.contains(this.spend2_id.parentElement.classList, 'active-select')) {
            this.spend2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend3_id.parentElement.classList, 'active-select')) {
            this.spend3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend4_id.parentElement.classList, 'active-select')) {
            this.spend4_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.spend1_id.parentElement.classList, 'active-select')) {
            this.spend1_id.parentElement.classList.remove('active-select');
          }
          this.spend5_id.parentElement.classList.add('active-select');
        }
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgType = {
        opt1: false,
        opt2: false,
        opt3: false,
        opt4: false,
        opt5: false
      };
      this.hoursSpend = '';
      if (_.contains(this.spend1_id.parentElement.classList, 'active-select')) {
        this.spend1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.spend2_id.parentElement.classList, 'active-select')) {
        this.spend2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.spend3_id.parentElement.classList, 'active-select')) {
        this.spend3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.spend4_id.parentElement.classList, 'active-select')) {
        this.spend4_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.spend5_id.parentElement.classList, 'active-select')) {
        this.spend5_id.parentElement.classList.remove('active-select');
      }
      this.user_bot = false;
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    }
    this.save();

    if (this.isChecked === true) 
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }
    }
  }
  
  next() {
    if (_.isEmpty(this.hoursSpend)) {
      // alert('Select the Option');
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'home_stay_hrs',
      'fieldValue': this.hoursSpend
    };
    // console.log.log('res_question_id:::' + Obj);
    this.residentialService.updateResponses(Obj);
  }
}
